import React from 'react';
import AdditionalWorkForm from '../Forms/additional_work_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
];

function Additional_work() {
    return (
        <ManageDataPage
            title="Additional Work"
            endpoint="get_additional_work_table"
            columns={COLUMNS}
            editable={false}
            FormComponent={AdditionalWorkForm}
            searchPlaceholder="Search additional work..."
        />
    );
}

export default Additional_work;
